
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import MagicLinkLogin from './MagicLinkLogin';
import GoogleLogin from './GoogleLogin';

const LoginForm = () => {
  const [rememberMe, setRememberMe] = useState(false);

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader>
        <CardTitle>Log in to Bonjour!</CardTitle>
        <CardDescription>
          Enter your email or use Google to log in
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <MagicLinkLogin 
            rememberMe={rememberMe} 
            setRememberMe={setRememberMe} 
          />
          
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <Separator className="w-full" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-background px-2 text-muted-foreground">or</span>
            </div>
          </div>
          
          <GoogleLogin rememberMe={rememberMe} />
        </div>
      </CardContent>
      <CardFooter className="flex justify-center text-sm text-muted-foreground">
        We'll email you a magic link for a password-free sign in or use your Google account.
      </CardFooter>
    </Card>
  );
};

export default LoginForm;
